export default "<button mat-raised-button color=\"primary\" (click)=\"button.action($event)\">{{button.label}}</button>"